// src/components/Widgets.jsx
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const widgets = [
  // {
  //   id: 0,
  //   title: 'Free Mental Health Assessment',
  //   description: 'Not sure where to start? Our free online assessment can help guide your next steps.',
  //   image: '/img/icon-chart.svg',
  //   linkText: 'Take the Free Assessment',
  //   link: '#',
  // },
  {
    id: 1,
    title: 'Patient Login',
    description: 'Easily access your records, schedule appointments, and contact your care team in one secure place.',
    image: '/img/icon-contact.svg',
    linkText: 'Login',
    link: 'https://www.valant.io/myio/rp/login',
  }
];

const Widgets = () => {
  return (
    <div id="widgets-container" className="container">
      <div>
        {widgets.map((widget) => (
          <div key={widget.id} className="gradient">
            <div>
              <LazyLoadImage alt={widget.title} effect="blur" src={widget.image} />
              <h3>{widget.title}</h3>
              <p>{widget.description}</p>
              <a href={widget.link} className="button blue">{widget.linkText}</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Widgets;
